import React, { useReducer, useContext, useState } from 'react';
import api from './ApiCall';
import { TEST_LIST, QUESTION, ANSRESULT, TEST_RESULT, FEEDBACKSTATUS, FEEDBACKDATA, FEEDBACKSALESLIST, DashContext, LoginContext, CommonContext } from '../constant/ActionTypes';
import { dashRecuder } from '../reducer/dashRecuder';
import Loader from './../../common/Loader/Loader';

const initialState = {
    testList: [],
    question: {},
    ansresult: [],
    testResult: '',
    feedbackstatus: 0,
    feedbackdata:[{}],
    feedbackSalesList: []
}

const DashProvider = (props) => {
    const loginContext = useContext(LoginContext);
    const commonContext = useContext(CommonContext);

    const [dashtState, dispatch] = useReducer(dashRecuder, initialState);

    const [showLoader, setShowLoader] = useState(false);

    const getDashList = () => {
        if (loginContext && loginContext.loginDetails && loginContext.loginDetails.id) {
            api({ contentType: true, auth: true }).get(`DashboardService/getAll/user/${loginContext.loginDetails.id}`)
            .then((response) => {
                if (response.data.status.toLowerCase() === 'success') {
                    dispatch({
                        type: TEST_LIST,
                        payload: response.data.result
                    });
                    if (!(response.data.result && response.data.result.length > 0)) {
                        commonContext.updateLoaderMsg('No data found')
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }

    const getFeedbackSalesList = (page=null, offset=null) => {
        let pageLink = '';
        if (page) {
            pageLink = `?page=${page}&itemSize=${offset}`;
        }

        api({ contentType: true, auth: true }).get(`SalesExecService/getAll/${pageLink}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                console.log("List",response.data.result)
                dispatch({
                    type: FEEDBACKSALESLIST,
                    payload: response.data.result && response.data.result.content ? response.data.result.content : response.data.result
                });
                commonContext.updatePagination(response.data.result);
                if (
                    !(response.data.result && response.data.result.length > 0) ||
                    !(response.data.result && response.data.result.content && response.data.result.content.length > 0)
                ) {
                    commonContext.updateLoaderMsg('No data found')
                }
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const getFeedbackStatus = () => {
        if (loginContext && loginContext.loginDetails && loginContext.loginDetails.email) {
            api({ contentType: true, auth: true }).get(`FeedbackService/getfeedbackCount/${loginContext.loginDetails.email}`)
            .then((response) => {
                if (response.data.status.toLowerCase() === 'success') {
                    dispatch({
                        type: FEEDBACKSTATUS,
                        payload: response.data.result
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }

    const getFeedbackData = () => {
        if (loginContext && loginContext.loginDetails && loginContext.loginDetails.id) {
            api({ contentType: true, auth: true }).get(`FeedbackService/getBatchDetails/${loginContext.loginDetails.id}`)
            .then((response) => {
                if (response.data.status.toLowerCase() === 'success') {
                    if(response.data.result!=''){
                    dispatch({
                        type: FEEDBACKDATA,
                        payload: response.data.result
                    });
                }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }

    const submitFeedbackform = (user_id, course_id, feedbackContent) => {
        let data = {
            "user_id": user_id,
            "course_id": course_id,
            "email": loginContext.loginDetails.email,
            "feedback": feedbackContent
        }
        api({ contentType: true, auth: true }).post('FeedbackService/add', data)
        .then((response) => {
            if (response.data.status.toLowerCase() === 'success') {
                // getFeedbackStatus();
                getDashList();
            } 
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const clearDashList = () => {
        dispatch({
            type: TEST_LIST,
            payload: []
        });
    }

    const clearPrepare = () => {
        dispatch({
            type: QUESTION,
            payload: {}
        });
    }

    const getDashPrepare = (user_id, module_id, attempt) => {
        // setShowLoader(true);
        let data = {
            module_id,
            user_id,
            attempt
        }
        api({ contentType: true, auth: true }).post('TakeTestService/prepare', data)
        .then((response) => {
            if(response.data.status.toLowerCase()==='failure' && response.data.message==='No Question'){
                finishTest(user_id, module_id, attempt);
            }
            else if (response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: QUESTION,
                    payload: response.data
                });
                if (response.data.message === 'No questions to fetch') {
                    commonContext.updateLoaderMsg('No data found');
                }
            } else {
                commonContext.updateLoaderMsg('No data found');
            }
            // setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            // setShowLoader(false);
        });
    }

    const getSubmitQues = (user_history_id, options) => {
        setShowLoader(true);
        let data = {
            user_history_id,
            question_options : options
        }
        api({ contentType: true, auth: true }).post('TakeTestService/submitQ', data)
        .then((response) => {
            if (response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: ANSRESULT,
                    payload: response.data.result
                });
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }

    const getNextQues = (user_id, module_id, attempt) => {
        setShowLoader(true);
        let data = {
            module_id,
            user_id,
            attempt
        }
        api({ contentType: true, auth: true }).post('TakeTestService/nextQ', data)
        .then((response) => {
            if (response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: QUESTION,
                    payload: response.data
                });
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }
    
    const finishTest = (user_id, module_id, attempt) => {
        setShowLoader(true);
        let data = {
            module_id,
            user_id,
            attempt
        }
        api({ contentType: true, auth: true }).post('TakeTestService/submitTest', data)
        .then((response) => {
            // console.log(response.data, 'response.data');
            if (response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: TEST_RESULT,
                    payload: response.data.result.result
                });
                clearPrepare();
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }

    const clearTestResult = () => {
        dispatch({
            type: TEST_RESULT,
            payload: ''
        });
    }
    
    return (
        <DashContext.Provider
            value={{
                ...dashtState,
                getDashList: getDashList,
                getFeedbackSalesList: getFeedbackSalesList,
                getFeedbackStatus: getFeedbackStatus,
                getFeedbackData: getFeedbackData,
                submitFeedbackform: submitFeedbackform,
                getDashPrepare: getDashPrepare,
                clearPrepare: clearPrepare,
                getSubmitQues: getSubmitQues,
                getNextQues: getNextQues,
                finishTest: finishTest,
                clearTestResult: clearTestResult,
                clearDashList: clearDashList
            }}
        >
            {props.children}
            {showLoader && <Loader onlyLoading />}
        </DashContext.Provider>
    );
}

export default DashProvider;


// WEBPACK FOOTER //
// ./contexts/provider/DashContext.js